import { render, staticRenderFns } from "./press-item.vue?vue&type=template&id=5d51b9bb&"
import script from "./press-item.vue?vue&type=script&lang=js&"
export * from "./press-item.vue?vue&type=script&lang=js&"
import style0 from "./press-item.vue?vue&type=style&index=0&id=5d51b9bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports